import React from "react";

//import CommonLayout from "../../layout/common";

class Error404 extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            window.location.href = '/'
        }, 3000)
    }

    render() {
        return (
            <>
                {/*<CommonLayout>*/}

                <h1 style={{textAlign: "center", marginTop: "200px", color: "black"}}>404 | Not Found</h1>

                {/*// </CommonLayout>*/}
            </>
        )
    }
}

export default Error404;
